import React, { createContext, useState, useContext, useEffect } from "react";

// Creating the History Context
const HistoryContext = createContext();

export const useHistory = () => useContext(HistoryContext);

export const HistoryProvider = ({ children }) => {
  const [history, setHistory] = useState(() => {
    const savedHistory = localStorage.getItem("videoHistory");

    try {
      return savedHistory ? JSON.parse(savedHistory) : [];
    } catch {
      // Reset if data is corrupted
      localStorage.removeItem("videoHistory");
      return [];
    }
  });

  const addToHistory = (video) => {
    setHistory((prev) => {
      const videoExists = prev.some((v) => v.title === video.title);
      if (videoExists) return prev; // Avoid duplicates

      const updatedHistory = [video, ...prev];
      return updatedHistory;
    });
  };

  const deleteFromHistory = (videoTitle) => {
    setHistory((prev) => {
      const updatedHistory = prev.filter((video) => video.title !== videoTitle);
      return updatedHistory;
    });
  };

  useEffect(() => {
    localStorage.setItem("videoHistory", JSON.stringify(history));
  }, [history]);

  return (
    <HistoryContext.Provider value={{ history, addToHistory, deleteFromHistory }}>
      {children}
    </HistoryContext.Provider>
  );
};